module.exports = __webpack_public_path__ + "static/media/mountain_front.cea1ad8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Implementation/component/Game/img/mountain_front.png
// module id = 152
// module chunks = 0